// extracted by mini-css-extract-plugin
export default {"boolean":"pudtKjJhQaQq4QckkmrG","icon":"wwZsD_onLzp6EaUL9bCK","red":"_eNJRlOJ86pF_pjJbWLE"};